import { IContentcategory, ISubscribermarkcategorycontent } from '../teacher';

export enum SubscriberStatusEnum {
	DONE = 1,
	NEW = 2,
	SELECT_EDUCATION_PATH = 3,
	IN_PROGRESS = 4,
	CANCELED = 5,
	PAYMENT_NOT_COMPLETE_YET = 6,
	REJECTED = 7,
	ACCEPTED = 8,
	REQUEST_CANCEL = 9,
	RENEW_SUBSCRIPTION = 10,
	SUBSCRIPTION_RENEWED = 11,
	UNKNOWN_STATUS = 'UNKNOWN_STATUS',
}
export interface ICreateSubscriber {
	name: string;
	lname: string;
	dob: string;
	gender: string;
	street: string;
	city: string;
	pox: string;
	nationality: string;
	time_id: number;
	teacher_id?: number;
	paymentway_id?: number;
	level_ids?: number[];
	coupon_id?: number;
}

export interface IHomeStudent {
	id: number;
	name: string;
	lname: string;
	account_id: number;
	subscriberseminars: SubscriberSeminar[];
	subscriberplans: [
		{
			id: number;
			subscriber_id: number;
			item_id: number;
			item: {
				id: number;
				name: string;
			};
			from: number;
			to: number;
			firstMark: {
				from: number;
				to: number;
			};
			fromName?: string;
			toName?: string;
			lastMark: {
				from: number;
				to: number;
			};
			progress: number;
		},
	];
	seminarsession: {
		id: number;
		seminar_id: number;
		subscriber_id: number;
		date: string;
		seminar: {
			id: number;
			name: string;
			eduprogram_id: number;
		};
	};
	status: SubscriberStatusEnum;
}

export interface ISingleSubscriber {
	subscriber: Subscriber;
	marks: Mark[];
	subscribermarkcategorycontents: IContentcategory[];
}
export interface koraniUserDetail {
	id: number;
	korani_user_id: number;
	dob: string;
	nationality: string;
	gender: string;
	street: string;
	city: string;
	pox: string;
	photo: string | null;
	marital_status: string | null;
	iban: string | null;
	bank_name: string | null;
}

export interface IKoraniUser {
	id: number;
	name: string;
	lname: string;
	email: string | null;
	phone: string | null;
	username: string | null;
	password: string | null;
	parent_id: number | null;
	locale: string;
	payment_method: string;
	stripe_payment_method_id: string | null;
	stripe_customer_id: string | null;
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
	koraniuserdetail: koraniUserDetail;
}

export interface Subscriber {
	id: number;
	name: string;
	lname: string;
	account_id: number;
	subscriberattendances: SubscriberAttendance[];
	subscriberseminar: SubscriberSeminar;
	subscriberplans: IHomeStudent['subscriberplans'];
	homeworks: Homework[];
	subscribermarkcategorycontents: IContentcategory[];
}

export interface SubscriberAttendance {
	id: number;
	subscriber_id: number;
	seminar_id: number;
	val: number;
	created_at: string; // YYYY-MM-DD
}

export interface SubscriberSeminar {
	id: number;
	subscriber_id: number;
	seminar_id: number;
	seminar: Seminar;
}

export interface Seminar {
	id: number;
	name: string;
	eduprogram_id: number;
	eduprogram: EduProgram;
}

export interface EduProgram {
	id: number;
	name: string;
	items: EduItem[];
}

export interface EduItem {
	id: number;
	edupath_id: number;
	eduprogram_id: number;
	name: string;
	mark: number;
	success_mark: number;
	weight: number;
	ord: number;
	status: number;
	created_at: string; // ISO-Date
	academic_year_id: number;
	old_item_id: number | null;
	type: number;
}

export interface Homework {
	id: number;
	subscriber_id: number;
	seminar_id: number;
	item_id: number;
	body: string;
	created_at: string; // ISO-Date
	from: number;
	to: number;
}

export interface Mark {
	id: number;
	mark: number;
	note: string | null;
	from: number | null;
	to: number | null;
	created_at: string; // ISO-Date
	item_id: number;
	seminar_session_id: number;
	date: string | null;
	seminar_session: SeminarSession;
	subscribermarkcategorycontents?: ISubscribermarkcategorycontent[];
}

export interface SeminarSession {
	id: number;
	seminar_id: number;
	subscriber_id: number;
	type: string; // e.g. "COMPLETED"
	date: string; // YYYY-MM-DD
}

export interface IInvoice {
	id: number;
	number: string;
	customer_id: number;
	customer_type: number;
	customer_name: string | null;
	name: string;
	date: string;
	created_at: string;
	items: number;
	value: number;
	customer: string | null;
	accountcategory: {
		name: string;
		_locale: string;
	};
}

export enum SubscriberDetailTypeEnum {
	FULL = 'FULL',
	SUMMARY = 'SUMMARY',
	SELECT_SUBSCRIPTION = 'SELECT_SUBSCRIPTION',
	COMPLETE = 'COMPLETE',
}

export interface ISubscriberDetail {
	subscriber: Subscriber;
	age: number;
	nationality: string;
	ss: SubscriptionStatus;
	level_txt: string;
	seminar: SeminarInfo;
	paymentway: string;
	_seminar: Seminar;
	marks: any[];
	subscription: Subscription;
	sum: number;
	transactions: Transaction[];
	futures: FuturePayment[];
	setup_transaction: SetupTransaction;
	account: Account;
	eduprogram: EduProgram;
	type: SubscriberDetailTypeEnum;
	coupon: Coupon;
}

export interface Subscriber {
	id: number;
	account_id: number;
	type: number;
	username: string | null;
	password_clear: string | null;
	email: string | null;
	name: string;
	lname: string;
	gender: number;
	nationality: string;
	dob: string;
	por: string;
	address: string;
	street: string;
	pox: string;
	city: string;
	status: number;
	payment_completed: number;
	photo: string | null;
	payment_method: number;
	is_account: number;
	reject_reason: string | null;
	created_at: string;
	canceled_at: string | null;
	request_cancel: string | null;
	del: number;
	free: number;
	academic_year_id: number;
	old_subscriber_id: number;
}

export interface SubscriptionStatus {
	id: number;
	subscriber_id: number;
	level_id: string;
	eduprogram_id: number;
	school_id: number;
	total: number;
	fee: number;
	fee_one_time: number;
	payments_count: number;
	seminar_id: number;
	paymentway_id: number;
	payment_per_time: number;
	main_fee: number;
	coupon_id: number;
	discount: number;
	edupath_id: number;
	seminar_worktime_id: number;
	setup_paid: number;
	created_at: string;
	seminarworktime: SeminarWorktime;
	school: ISchool;
	paymentway: PaymentWay;
}

export interface SeminarWorktime {
	from_time: string;
	to_time: string;
	day: string;
}

export interface ISchool {
	id?: number;
	name: string;
	_locale: string;
}

export interface PaymentWay {
	payment: number;
}

export interface SeminarInfo {
	school_id: number;
	eduprogram_id: number;
	level_id: string;
	seminar_id: number;
	seminar_worktime_id: number;
	total: number;
	fee: number;
	fee_one_time: number;
	paymentway_id: number;
	payments_count: number;
	payment_per_time: number;
	coupon_id: number;
}

export interface Seminar {
	id: number;
	school_id: number;
	edupath_id: number;
	eduprogram_id: number;
	name: string;
	user_ids: string;
	min_joins: number;
	max_joins: number;
	current_joins: number;
	level: string;
	created_at: string;
	status: number;
	group_url: string;
	language: string;
	academic_year_id: number;
	old_subscriber_seminar_id: number;
	_locale: string;
}

export interface Subscription {
	id: number;
	subscription_id: string;
	status: string;
}

export interface Transaction {
	id: number;
	status: string;
	transaction_id: string;
	gross_amount: number;
	currency: string;
	created_at: string;
	given_name: string;
	surname: string;
	payer_email: string;
}

export interface FuturePayment {
	status: number;
	date: string;
	id: number;
	transaction_id: string | null;
}

export interface SetupTransaction {
	transaction_id: string;
	id: number;
}

export interface Account {
	id: number;
	name: string;
	lname: string;
	prefix: string;
	mob: string;
	username: string;
	username2: string;
	username3: string;
	subscribers_count: number;
	photo: string | null;
	email: string | null;
	created_at: string;
	status: number;
	type: number;
	del: number;
	payment_methods: string;
	token: string | null;
	locale: string;
}

export interface EduProgram {
	id: number;
	type: number;
	edupath_id: number;
	name: string;
	level_txt: string;
	language: string;
	min_join: number;
	max_join: number;
	current_joins: number;
	period: number;
	from_date: string;
	first_semester_end: string;
	to_date: string;
	books: number;
	group_url: string;
	invite_code: string;
	subscribe_cost: number;
	subscribe_type: number;
	subscribe_count: number;
	subscribe_payment: number;
	mark: number;
	semester_weight: number;
	finaltest_weight: number;
	behavior_weight: number;
	one_time_reg_fee: number;
	created_at: string;
	status: number;
	product_id: string;
	academic_year_id: number;
	old_eduprogram_id: number;
	_locale: string;
}

export interface Coupon {
	id: number;
	coupon_group_id: number;
	type: number;
	name: string;
	code: string;
	discount: number;
	expired_at: string;
	uses: number;
	used: number;
	subscriber_id: number;
	created_at: string;
	academic_year_id: number;
}
